import React from 'react';
import classNames from 'classnames';

import { IntegrationTab, IntegrationValue } from './types';
import { GongIntegrationIcon, GoogleDriveIntegrationIcon, BoxIntegrationIcon } from 'src/monet/icons';
import microsoftLogo from 'src/logos/microsoft.svg';
import { useCurrentOrganization } from 'src/store/organization';
import DropboxIntegrationIcon from 'src/monet/icons/DropboxIntegrationIcon';

const INTEGRATION_TABS = [
  {
    icon: (
      <svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M12.899 6.86047C12.3886 6.84141 11.8802 6.83505 11.3846 6.84564C11.9374 5.0368 13.4264 0.171564 13.4264 0.171564L13.4794 0H6.84767V1.17977H11.535L9.82993 6.93884C9.34066 6.98756 8.85562 7.05322 8.38964 7.1337C5.99197 7.56156 2.79154 8.62907 1.16909 11.2746C0.563318 12.2637 0.154528 13.8184 1.00388 14.9473C1.42961 15.5128 2.1773 15.8983 3.00335 15.9788C3.15585 15.9936 3.30624 16 3.45662 16C5.69755 16 7.65043 14.3966 8.77089 12.8186L8.82808 12.7382C10.0079 11.0458 10.6772 9.15647 11.177 7.52343C11.696 7.46201 12.2361 7.41753 12.8143 7.38364C12.8355 7.20572 12.8651 7.02992 12.899 6.85624V6.86047ZM9.14156 9.03362C8.44047 10.7874 7.68008 12.1112 6.75448 13.2041C6.23766 13.8141 5.71026 14.2568 5.14261 14.5597C4.26149 15.0299 3.35495 15.1295 2.71953 14.8223C1.98455 14.4686 1.84052 13.6002 1.94007 12.9627C2.06716 12.1493 2.52678 11.48 2.89109 11.0627C4.31021 9.42971 6.50242 8.3516 9.59059 7.77125C9.4635 8.18004 9.31524 8.59518 9.14156 9.03362Z'
          fill='currentColor'
        />
      </svg>
    ),
    label: 'Journey',
    value: 'journey',
  },
  {
    icon: <GoogleDriveIntegrationIcon className='w-5 h-5' />,
    label: 'Google Drive',
    value: 'google-drive',
  },
  {
    icon: <DropboxIntegrationIcon className='w-5 h-5' />,
    label: 'Dropbox',
    value: 'dropbox',
  },
  {
    icon: <GongIntegrationIcon className='w-5 h-5' />,
    label: 'Gong',
    value: 'gong',
  },
  {
    icon: <BoxIntegrationIcon className='w-5 h-5' />,
    label: 'Box',
    value: 'box',
  },
  // }, {
  //   icon: (
  //     <img src={microsoftLogo} className="w-5 h-5" />
  //   ),
  //   label: 'Microsoft One Drive',
  //   value: 'microsoft-one-drive',
] as IntegrationTab[];

type MediaIntegrationsPanelProps = {
  activeTabValue: IntegrationValue;
  onTabValueChange: (value: IntegrationValue) => void;
};

export const MediaIntegrationsPanel = ({ activeTabValue, onTabValueChange }: MediaIntegrationsPanelProps) => {
  const onTabClick = (value: IntegrationValue) => {
    if (value !== activeTabValue) {
      onTabValueChange(value);
    }
  };

  return (
    <div className='flex space-x-1 items-center bg-transparent h-10 w-full' aria-label='Integrations'>
      {INTEGRATION_TABS.map((tab: IntegrationTab) => (
        <div
          className={classNames(
            'hover:bg-neue-journey-fg-10 transition-colors rounded-lg cursor-pointer h-10 w-10 text-neue-journey-fg flex items-center justify-center flex-shrink-0',
            {
              'bg-neue-journey-fg-10': activeTabValue === tab.value,
              'bg-transparent': activeTabValue !== tab.value,
            }
          )}
          onClick={() => onTabClick(tab.value)}
        >
          {tab.icon}
        </div>
      ))}
    </div>
  );
};
